<template>
  <v-dialog
    v-if="theProduct"
    v-model="dialog"
    persistent
    max-width="1100px"
    ref="winPresent"
  >
    <v-card>
      <v-card-title>
        <div class="d-flex flex-column card-title">
          <div>{{ theProduct.pr_ref }}</div>
          <div class="title-designation">{{ theProduct.pr_name_fr }}</div>
        </div>
      </v-card-title>
      <v-card-text grid-list-xl :style="stylecontainer">
        <v-row ref="mycontainer">
          <v-col cols="3">
            <div class="container-image">
              <v-img
                :src="
                  productPhotos.photo1.binary
                    ? productPhotos.photo1.binary
                    : `${$config.server_url}/api/1.0/products/image/${theProduct.pr_ref}/1/200/150?d=${now}`
                "
                contain
                width="200px"
                height="150px"
              ></v-img>

              <v-checkbox
                hide-details
                label="Supprimer"
                v-model="deletePhoto1"
                class="mr-4 checkbox-delete-img"
              ></v-checkbox>
              <v-btn
                @click="editPhoto('photo1')"
                depressed
                small
                class="btn-edit-img primary2"
                >Modifier</v-btn
              >
              <input
                hidden
                type="file"
                ref="inputProductPhoto1"
                name="productPhoto1"
                accept="image/png, image/jpeg"
                @change="changeProductPhoto($event, 'photo1')"
              />
            </div>
            <div class="container-image mt-3">
              <v-img
                :src="
                  productPhotos.photo2.binary
                    ? productPhotos.photo2.binary
                    : `${$config.server_url}/api/1.0/products/image/${theProduct.pr_ref}/2/200/150?d=${now}`
                "
                contain
                width="200px"
                height="150px"
              ></v-img>

              <v-checkbox
                hide-details
                label="Supprimer"
                v-model="deletePhoto2"
                class="mr-4 checkbox-delete-img"
              ></v-checkbox>
              <v-btn
                @click="editPhoto('photo2')"
                depressed
                small
                class="btn-edit-img primary2"
                >Modifier</v-btn
              >
              <input
                hidden
                type="file"
                ref="inputProductPhoto2"
                name="productPhoto1"
                accept="image/png, image/jpeg"
                @change="changeProductPhoto($event, 'photo2')"
              />
            </div>
            <div class="container-image mt-3">
              <v-img
                :src="
                  productPhotos.photo3.binary
                    ? productPhotos.photo3.binary
                    : `${$config.server_url}/api/1.0/products/image/${theProduct.pr_ref}/3/200/150?d=${now}`
                "
                contain
                width="200px"
                height="150px"
              ></v-img>

              <v-checkbox
                hide-details
                label="Supprimer"
                v-model="deletePhoto3"
                class="mr-4 checkbox-delete-img"
              ></v-checkbox>
              <v-btn
                @click="editPhoto('photo3', e)"
                depressed
                small
                class="btn-edit-img primary2"
                >Modifier</v-btn
              >
              <input
                hidden
                type="file"
                ref="inputProductPhoto3"
                name="productPhoto3"
                accept="image/png, image/jpeg"
                @change="changeProductPhoto($event, 'photo3')"
              />
            </div>
          </v-col>
          <v-col cols="6">
            <m-form-text
              :name="$Utils.randomstring('pr_ref')"
              label="Référence"
              label-position="top"
              v-model="theProduct.pr_ref"
              :value="theProduct.pr_ref"
              :disabled="true"
            ></m-form-text>
            <m-form-text
              :name="$Utils.randomstring('pr_name_fr')"
              label="Nom du produit FR"
              label-position="top"
              v-model="theProduct.pr_name_fr"
              :value="theProduct.pr_name_fr"
              :disabled="true"
            ></m-form-text>
            <m-form-text
              :name="$Utils.randomstring('pr_name_en')"
              label="Nom du produit EN"
              label-position="top"
              v-model="theProduct.pr_name_en"
              :value="theProduct.pr_name_en"
              :disabled="true"
            ></m-form-text>
            <m-form-text
              :name="$Utils.randomstring('pr_name_sp')"
              label="Nom du produit SP"
              label-position="top"
              v-model="theProduct.pr_name_sp"
              :value="theProduct.pr_name_sp"
              :disabled="true"
            ></m-form-text>
            <m-form-text
              :name="$Utils.randomstring('pr_name_pl')"
              label="Nom du produit PL"
              label-position="top"
              v-model="theProduct.pr_name_pl"
              :value="theProduct.pr_name_pl"
              :disabled="true"
            ></m-form-text>
            <!-- <m-form-text
              type="textarea"
              :name="$Utils.randomstring('pr_description')"
              label="Description du poduit"
              label-position="top"
              v-model="theProduct.pr_description"
              :value="theProduct.pr_description"
              :disabled="true"
            ></m-form-text>-->
            <m-form-text
              :name="$Utils.randomstring('pr_color')"
              label="Couleur"
              label-position="top"
              v-model="theProduct.pr_color"
              :value="theProduct.pr_color"
              :disabled="true"
            ></m-form-text>
            <v-row>
              <v-col cols="6">
                <m-form-text
                  :name="$Utils.randomstring('pr_marque')"
                  label="Marque"
                  label-position="top"
                  v-model="theProduct.pr_marque"
                  :value="theProduct.pr_marque"
                  :disabled="true"
                ></m-form-text>
              </v-col>
              <v-col cols="6">
                <m-form-text
                  :name="$Utils.randomstring('pr_mmd')"
                  label="MMD / Reférencement"
                  label-position="top"
                  v-model="theProduct.pr_mmd"
                  :value="theProduct.pr_mmd"
                  :disabled="true"
                ></m-form-text>
              </v-col>
            </v-row>
            <m-form-text
              :name="$Utils.randomstring('pr_society')"
              label="Société"
              label-position="top"
              v-model="theProduct.pr_society"
              :value="theProduct.pr_society"
              :disabled="true"
            ></m-form-text>
            <v-row>
              <v-col cols="4">
                <m-form-combobox
                  v-model="theProduct.level1"
                  label="Famille"
                  labelPosition="top"
                  :name="$Utils.randomstring('search-family')"
                  :store-url="
                    $config.server_url + '/api/1.0/families/combobox/1'
                  "
                  :store-params="{ catalog: 0 }"
                  item-text="fa_name_fr"
                  item-value="fa_id"
                  :disabled="true"
                ></m-form-combobox>
              </v-col>
              <v-col cols="4">
                <m-form-combobox
                  v-model="theProduct.level2"
                  label="Sous-famille"
                  labelPosition="top"
                  :name="$Utils.randomstring('search-subfamily')"
                  :store-url="
                    $config.server_url + '/api/1.0/families/combobox/2'
                  "
                  :store-params="{ family: 0 }"
                  item-text="fa_name_fr"
                  item-value="fa_id"
                  :disabled="true"
                ></m-form-combobox>
              </v-col>
              <v-col cols="4">
                <m-form-combobox
                  v-model="theProduct.level2"
                  label="Segment"
                  labelPosition="top"
                  :name="$Utils.randomstring('search-subfamily')"
                  :store-url="
                    $config.server_url + '/api/1.0/families/combobox/3'
                  "
                  :store-params="{ family: 0 }"
                  item-text="fa_name_fr"
                  item-value="fa_id"
                  :disabled="true"
                ></m-form-combobox>
              </v-col>
            </v-row>
            <m-form-text
              :name="$Utils.randomstring('pr_gamme')"
              label="Gamme / Collection"
              label-position="top"
              v-model="theProduct.pr_gamme"
              :value="theProduct.pr_gamme"
              :disabled="true"
            ></m-form-text>
            <m-form-text
              :name="$Utils.randomstring('pr_pack')"
              label="Type de pack"
              label-position="top"
              v-model="theProduct.pr_pack_type"
              :value="theProduct.pr_pack_type"
              :disabled="true"
            ></m-form-text>
          </v-col>
          <v-col cols="3">
            <m-form-text
              :name="$Utils.randomstring('pr_bar_code')"
              label="Gencode"
              label-position="top"
              v-model="theProduct.pr_bar_code"
              :value="theProduct.pr_bar_code"
              :disabled="true"
            ></m-form-text>
            <m-form-text
              :name="$Utils.randomstring('pr_pack_bar_code')"
              label="Gencode du carton"
              label-position="top"
              v-model="theProduct.pr_pack_bar_code"
              :value="theProduct.pr_pack_bar_code"
              :disabled="true"
            ></m-form-text>
            <v-row>
              <v-col cols="8">
                <m-form-text
                  :name="$Utils.randomstring('pr_pcb_type')"
                  label="type de PCB"
                  label-position="top"
                  v-model="theProduct.pr_pcb_type"
                  :value="theProduct.pr_pcb_type"
                  :disabled="true"
                ></m-form-text>
              </v-col>
              <v-col cols="4">
                <m-form-text
                  :name="$Utils.randomstring('pr_pack_number')"
                  label="PCB"
                  label-position="top"
                  v-model="theProduct.pr_pack_number"
                  :value="theProduct.pr_pack_number"
                  :disabled="true"
                ></m-form-text>
              </v-col>
            </v-row>
            <m-form-text
              :name="$Utils.randomstring('pr_delais')"
              label="Delais"
              label-position="top"
              v-model="theProduct.pr_delais"
              :value="theProduct.pr_delais"
              :disabled="true"
            ></m-form-text>
            <m-form-text
              :name="$Utils.randomstring('pr_promo')"
              label="Type de promo"
              label-position="top"
              v-model="theProduct.pr_promo"
              :value="theProduct.pr_promo"
              :disabled="true"
            ></m-form-text>
            <v-checkbox
              class
              hide-details
              v-model="theProduct.pr_recycled"
              label="Recyclé"
            ></v-checkbox>
            <v-checkbox
              class
              hide-details
              v-model="theProduct.pr_recycling"
              label="Recyclage"
            ></v-checkbox>
            <v-checkbox
              class
              hide-details
              v-model="theProduct.pr_natural_fiber"
              label="Fibres naturelles"
            ></v-checkbox>
            <v-checkbox
              class
              hide-details
              v-model="theProduct.pr_manufacturing_fr"
              label="Fabriqué en France"
            ></v-checkbox>
            <v-checkbox
              class
              hide-details
              v-model="theProduct.pr_manufacturing_ue"
              label="Fabriqué en Europe"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <!-- <v-btn color="error2" @click="confirmDeleteDialog=true">Effacer</v-btn> -->
        <v-spacer></v-spacer>
        <v-btn class="primary2--text" color text @click="cancelWin()"
          >Annuler</v-btn
        >
        <v-btn
          color="primary2"
          @click="saveWin()"
          :disabled="!$store.state.myrights.create_catalogue"
          >Enregistrer</v-btn
        >
      </v-card-actions>
    </v-card>
    <m-confirm-dialog
      v-model="confirmDeleteDialog"
      text="Souhaitez-vous effacer ce produit ?"
      title="Confirmation"
      @canceled="confirmDeleteDialog = false"
      @confirmed="deleteWin()"
    ></m-confirm-dialog>
  </v-dialog>
</template>

<script>
export default {
  name: "actionwinedit",
  props: ["product"],
  components: {},
  data() {
    // let row_ac = { ac_report: {} };
    return {
      theProduct: {
        level1: null,
        level2: null
      },
      dialog: false,
      stylecontainer: ``,
      confirmDeleteDialog: false,
      productPhotos: {
        photo1: { photo: null, binary: null },
        photo2: { photo: null, binary: null },
        photo3: { photo: null, binary: null }
      },
      productPhotosRefs: {
        photo1: "inputProductPhoto1",
        photo2: "inputProductPhoto2",
        photo3: "inputProductPhoto3"
      },
      deletePhoto1: false,
      deletePhoto2: false,
      deletePhoto3: false,
      now: new Date().getTime()
    };
  },
  computed: {
    /*     now() {
      return new Date().getTime();
    } */
  },
  mounted() {
    // console.log("theProduct.pr_photo1", this.theProduct.pr_photo1);
    window.addEventListener("resize", this.setContainerStyle);
  },
  destroyed() {
    window.removeEventListener("resize", this.setContainerStyle);
  },
  watch: {},
  methods: {
    setContainerStyle() {
      let me = this;
      function go() {
        if (!me.$refs.mycontainer) return;
        if (me.$refs.mycontainer.clientHeight > window.innerHeight - 300)
          me.stylecontainer = `height: calc(100vh - 253px); overflow:auto;`;
        else me.stylecontainer = "";
      }
      go();
      window.setTimeout(go, 100);
      window.setTimeout(go, 1000);
    },
    async open(pr_id) {
      this.deletePhoto1 = false;
      this.deletePhoto2 = false;
      this.deletePhoto3 = false;
      this.productPhotos = {
        photo1: { photo: null, binary: null },
        photo2: { photo: null, binary: null },
        photo3: { photo: null, binary: null }
      };
      this.now = new Date().getTime();
      if (!pr_id) {
        pr_id = "-1";
      }
      let response = await this.$axios.get(
        this.$config.server_url + "/api/1.0/products/" + pr_id
      );
      // console.log("response.data.data", response.data.data);
      this.theProduct = response.data.data;

      this.dialog = true;
      this.setContainerStyle();
    },
    editPhoto(photo) {
      let inputRef = this.productPhotosRefs[photo];
      this.$refs[inputRef].click();
    },

    changeProductPhoto(e, photo) {
      if (!e.target.files.length) return;
      this.productPhotos[photo].photo = e.target.files[0];
      var reader = new FileReader();
      var me = this;
      reader.onload = (function(theFile) {
        return function(e) {
          me.productPhotos[photo].binary = e.target.result;
        };
      })(e.target.files[0]);
      reader.readAsDataURL(e.target.files[0]);
    },
    cancelWin() {
      // this.$router.go(-1);
      this.$emit("productWinEditCanceled");
      this.dialog = false;
    },
    async saveWin() {
      await this.$axios.put(
        this.$config.server_url + "/api/1.0/products/" + this.theProduct.pr_id,
        {
          deletePhoto1: this.deletePhoto1,
          deletePhoto2: this.deletePhoto2,
          deletePhoto3: this.deletePhoto3
        }
      );
      let me = this;
      async function savePhoto(file, indexPhoto) {
        if (!file) return;
        let formData = new FormData();
        formData.append("file", file);
        await me.$axios.post(
          me.$config.server_url +
            "/api/1.0/products/" +
            me.theProduct.pr_id +
            "/image/" +
            indexPhoto,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        );
      }
      await savePhoto(this.productPhotos.photo1.photo, 1);
      await savePhoto(this.productPhotos.photo2.photo, 2);
      await savePhoto(this.productPhotos.photo3.photo, 3);
      this.dialog = false;
      this.productWinEditSaved();

      // this.$router.go(-1);
    },
    productWinEditSaved() {
      this.$emit("productWinEditSaved");
    },
    async deleteWin() {
      this.confirmDeleteDialog = false;
      this.dialog = false;
    }
  }
};
</script>

<style scoped lang="scss">
.card-title {
  text-align: left;
}
.title-designation {
  font-size: 16px;
}
.container-image {
  position: relative;
  width: 100%;
  height: 200px;
  border: solid 1px #ebebeb;
}
.container-image .v-image {
  margin-right: auto;
  margin-left: auto;
}
.btn-edit-img {
  position: absolute;
  bottom: 5px;
  right: 5px;
}
.checkbox-delete-img {
  position: absolute;
  bottom: 5px;
  left: 5px;
}
</style>
